import { render, staticRenderFns } from "./kaobo.vue?vue&type=template&id=197791ac&scoped=true"
import script from "./kaobo.vue?vue&type=script&lang=js"
export * from "./kaobo.vue?vue&type=script&lang=js"
import style0 from "./kaobo.vue?vue&type=style&index=0&id=197791ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197791ac",
  null
  
)

export default component.exports